var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 0 5px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "background": "#fff",
      "margin": "0 0 1px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "100%",
      "text-align": "start",
      "font-size": "16px",
      "padding": "16px 0 12px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "height": "14px",
      "border-left": "solid 4px #ff8a05",
      "padding-left": "6px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.payment.create_time.substring(0, 16)) + "\n\t\t\t")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allowEdit),
      expression: "allowEdit"
    }],
    staticStyle: {
      "margin-right": "16px"
    },
    on: {
      "click": _vm.toEdit
    }
  }, [_vm._v("编辑")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-item"
  }, [_c('ul', {
    staticClass: "info-cont"
  }, [(!_vm.is_trans) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款方式")]), _c('span', [_vm._v(_vm._s(_vm.payment.vendor_title))])]) : _vm._e(), _vm._v(" "), (_vm.is_trans) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款方式")]), _c('span', [_vm._v("转账")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款金额")]), _c('span', [_vm._v(_vm._s(_vm.payment.amount) + "元")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款日期")]), _c('span', [_vm._v(_vm._s(_vm.paid_time))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "height": "24px",
      "line-height": "24px"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "padding": "0",
      "vertical-align": "middle"
    }
  }, [_vm._v("付款状态")]), _c('span', {
    class: _vm.payStatusClass,
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.payment.pay_status_title))]), _vm._v(" "), (this.payment.is_trans && _vm.payment.pay_status === 70) ? _c('span', {
    staticStyle: {
      "display": "inline-flex",
      "height": "24px",
      "background": "#459AFF",
      "border-radius": "4px",
      "align-items": "center",
      "vertical-align": "middle",
      "padding": "0 6px 0 4px",
      "gap": "2px"
    },
    on: {
      "click": _vm.toEdit
    }
  }, [_c('span', {
    staticClass: "ic-pen-edit"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "color": "#fff",
      "line-height": "18px"
    }
  }, [_vm._v("修改")])]) : _vm._e()]), _vm._v(" "), (_vm.is_trans) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("转入账户")]), _c('span', [_vm._v(_vm._s(_vm.payment.payment_way) + "（" + _vm._s(_vm.payment.hz_bank_account) + "）")])]) : _vm._e(), _vm._v(" "), (_vm.is_trans && _vm.payment.bank_name) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款银行")]), _c('span', [_vm._v(_vm._s(_vm.payment.bank_name))])]) : _vm._e(), _vm._v(" "), (_vm.is_trans && _vm.payment.bank_account_name) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款账户")]), _c('span', [_vm._v(_vm._s(_vm.payment.bank_account_name))])]) : _vm._e(), _vm._v(" "), (_vm.has_trade_no) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款单号")]), _c('span', [_vm._v(_vm._s(_vm.payment.trade_no))])]) : _vm._e(), _vm._v(" "), (_vm.has_alipayid) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款账号")]), _c('span', [_vm._v(_vm._s(_vm.payment.alipay_id))])]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-71eb98f4","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderPayItem.vue
// module id = 248
// module chunks = 0